/* eslint-disable handle-callback-err */
/*
  APIアクセスの共通例処理 セッションがある場合に利用
  バックエンドリソースサーバーへのAPIアクセスはこのライブラリを経由したAxiosを利用する。
*/
import axios from 'axios'
import store from '../vuex/store'
import settings from '../settings'
import { toLoginPage } from './redirect'
import { beforeHttpHandler, sessionErrorHandler, successHttpHandler, isTokenExpired, updateAccessToken } from './utils'

// バックエンドAPIのベースURL
const baseUrl = settings.ApiUrl

const http = axios.create({
  baseURL: baseUrl
})

// リクエスト時の共通処理
http.interceptors.request.use((config) => {
  beforeHttpHandler()

  // Languageをヘッダーに埋め込む設定
  config.headers['Accept-Language'] = store.state.login.profile.language

  // Tokenをヘッダーに埋め込む設定
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
    return config
  } else {
    toLoginPage()
  }
}, function (error) {
  return Promise.reject(error)
})

// レスポンス時の共通処理
http.interceptors.response.use(
  (res) => {
    if (isTokenExpired()) {
      // give a refresh token if not expired, get in return an access token
      // if the access token is expired and refresh is not, get a new one
      // Tokenの時間をチェックして時間を切っている場合
      // 有効期限がリセットされた新しいTokenをバックエンドサーバーよりもらって上書き
      updateAccessToken()
    }
    // 成功処理
    successHttpHandler()
    return res
  },
  (error) => {
    sessionErrorHandler(error)
    return Promise.reject(error)
  }
)

export default http
